import { Component, HostBinding } from '@angular/core';
import { Organisation, OrganizationsService } from '../../organizations.service';
import { INavData } from '@coreui/angular';

import { navItems } from './_nav';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
})
export class DefaultLayoutComponent {
  @HostBinding('class.c-app') cAppClass = true;

  public navItems;
  public perfectScrollbarConfig = {
    suppressScrollX: true,
  };

  ngOnInit(): void {
  }

  constructor( private org: OrganizationsService) {
    this.org.getOrganisations().subscribe(organisations_data => {
      if (navItems[1].name != 'Helyszínek') {
        //helyszínek átalakítása Nav datába, majd összehűzése egy dropdown gyűjtővel
        let locationNavData: INavData[] = [];

        for (let i = 0; i < organisations_data.length; i++) {
          const element = organisations_data[i];
          let orgUrl = '/organizations/' + element.id;
          locationNavData.splice(i, 0, {
            name: element.title,
            icon: 'cil-building',
            url: orgUrl
          });     
        }
      
        //dropdown helyszíneknek, c-show kell, hogy már betöltéskor nyitva legyen
        navItems.splice(1, 0,{
          name: 'Helyszínek',
          icon: 'cil-list',
          url: '/organizations',
          class: 'openpls',
          children: locationNavData
        });
      }
      this.navItems = navItems;      
    });
  }
}
